import { CLEAR_STORE } from '../constants';
import { CLOSE_SG_DIALOG, OPEN_SG_DIALOG, UNMOUNT_DIALOG } from '../constants/sg-dialog';

const initialState = {};

export const dialogReducer = (state = initialState, { payload, type, id }) => {
  switch (type) {
    case OPEN_SG_DIALOG:
      return {
        ...state,
        [id]: Array.isArray(payload) ? [...payload] : { ...payload }
      };
    case CLOSE_SG_DIALOG:
    case UNMOUNT_DIALOG:
      return {
        ...state,
        [id]: undefined
      };
    case CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};
